/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import DatePicker from '@roo/roo/DatePicker';
import Select, { SelectOptions } from '@roo/roo/Select';
import Form from '@roo/roo/Form';
import Button from '@roo/roo/Button';
import Grid from '@roo/roo/Grid';
import dayjs from 'dayjs';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import {
    ICooperateList,
    ILiveAnyliseFormProps,
    SubmitReq,
    TABLE_TYPE,
    getAnalysisDownloadSubmit,
} from '../api';

dayjs.extend(CustomParseFormat);

const { RangePicker } = DatePicker;
const { Field } = Form;
const { Row, Col } = Grid;

const defaultFormValue: SubmitReq = {
    type: TABLE_TYPE.DAILY,
    customerSource: '',
    startDate: '',
    endDate: '',
    queryDate: '',
    coopMode: '',
};

const Index = (props: ILiveAnyliseFormProps) => {
    const { customerSources, type, title, updateTableData } = props;
    const formRef = React.useRef<Form>(null);
    const [formValue, setFormValue] = useState<SubmitReq>({
        ...defaultFormValue,
        type,
    });
    const [load, setLoad] = useState<boolean>(false);
    const [coopModeList, setCoopModeList] = useState<ICooperateList>([]); // 合作模式筛选项

    const rules = {
        customerSource: {
            required: true,
            message: '客户来源必填',
        },
        coopMode: {
            required: true,
            message: '合作模式必填',
        },
        queryDate: [
            {
                validator(rule: any, value: any, callback: any) {
                    if (!value) callback('请填写日期');
                    else {
                        const a = dayjs(value[0], 'YYYYMMDD');
                        const b = dayjs(value[1], 'YYYYMMDD');
                        const dif = b.diff(a, 'day');
                        if (dif > 30) callback('日期间隔不能超过30天');
                        else callback();
                    }
                },
            },
        ],
    };
    const cols = {
        label: { span: 4 },
        field: { span: 8 },
    };

    /**
     * 禁用日前范围
     * @param cur 当前日期
     * @returns 日期不得大于 今天往后的日子
     */
    const disableDate = (cur: dayjs.Dayjs) => +cur > Date.now() - 86400000;

    const renderDateSelect = () => (
        <RangePicker format="YYYYMMDD" valueOfType="string" disabledDate={disableDate} />
    );

    const renderCustomerSelect = () => {
        const options: SelectOptions[] = customerSources.map(e => ({
            value: e.value,
            label: e.label,
        }));
        return <Select options={options} />;
    };

    const renderCooperateSelect = () => (
        <Select options={coopModeList} style={{ width: '200px' }} />
    );

    return (
        <>
            <p>{title}</p>
            <Form
                value={{}}
                rules={rules}
                ref={formRef}
                layout="horizontal"
                cols={cols}
                onChange={(name: string, value: any) => {
                    if (!value) return;
                    if (name === 'queryDate') {
                        setFormValue({ ...formValue, startDate: value[0], endDate: value[1] });
                    } else if (name === 'customerSource') {
                        const list =
                            customerSources.find(e => e.value.toString() === value.toString())
                                ?.modes ?? [];
                        setCoopModeList(list);
                        formRef.current?.setFieldValue('coopMode', ''); // 改变客户来源，合作模式置空
                        setFormValue({
                            ...formValue,
                            [name]: value,
                            coopMode: '',
                        });
                    } else {
                        setFormValue({ ...formValue, [name]: value });
                    }
                }}
                onSubmit={(value: any, error: any) => {
                    if (error) return;
                    setLoad(true);
                    getAnalysisDownloadSubmit(formValue)
                        .then(res => {
                            updateTableData();
                            setLoad(false);
                        })
                        .catch(() => {
                            setLoad(false);
                        });
                }}
            >
                {({ submitForm }: any) => (
                    <form>
                        <Row>
                            <Col span={3}>
                                <Field label="日期选择" name="queryDate" as={renderDateSelect()} />
                            </Col>
                            <Field
                                label="客户来源"
                                name="customerSource"
                                as={renderCustomerSelect()}
                            />
                            <Field
                                label="合作模式"
                                name="coopMode"
                                as={renderCooperateSelect()}
                                disabled={formValue.customerSource === ''}
                            />
                            <Col span={1}>
                                <Field>
                                    <Button loading={load} type="hollow" onClick={submitForm}>
                                        {`下载${title}`}
                                    </Button>
                                </Field>
                            </Col>
                        </Row>
                    </form>
                )}
            </Form>
        </>
    );
};

export default Index;
